import { QContentStatusTag } from '@exam-management/components';
import {
  QuestionGroupType,
  type QuestionGroup,
  type QuestionGroupStatus,
  type QuestionStatus,
} from '@exam-management/graphql';
import { EllipsisText, Text, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { QContentListRowMoreActionMenu, QContentQuestionTypeChip } from '../../components';

interface ItemSet {
  id: string;
  name: QuestionGroup['name'];
  refCode: string;
  status: QuestionGroupStatus;
  totalQuestions: number;
  type: QuestionGroup['type'];
  updatedAt: Date;
}

export const columns: GridColDef<ItemSet>[] = [
  {
    field: 'refCode',
    headerName: 'QID',
    width: 200,
    sortable: false,
    renderCell: (params) => {
      return <Text variant='body2'>{params.value}</Text>;
    },
  },
  {
    field: 'questionGroup.name',
    headerName: 'QType',
    width: 128,
    sortable: false,
    renderCell: () => {
      return <QContentQuestionTypeChip type={QuestionGroupType.ItemSet} />;
    },
  },
  {
    field: 'questionGroup.type',
    headerName: 'Item Set/LOQ of',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      const { type, totalQuestions } = params.row;
      if (type === QuestionGroupType.Single) return null;

      return (
        <EllipsisText>
          <Text component='span' variant='body2Semibold' sx={{ mr: 2.5 }}>
            {params.row.name ?? ''}
          </Text>
          <Text component='span' variant='body2'>
            {`(${totalQuestions} Questions)`}
          </Text>
        </EllipsisText>
      );
    },
  },
  {
    field: 'updatedAt',
    headerName: 'Last Modified',
    width: 160,
    renderCell: (params) => {
      return <>{formatDateTime(params.value)}</>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      const status = params.value as QuestionStatus;
      return <QContentStatusTag status={status} size='large' />;
    },
  },
  {
    field: 'moreAction',
    headerName: '',
    width: 36,
    sortable: false,
    renderCell: (params) => {
      const questionGroupType = params.row.type;
      const questionGroupStatus = params.row.status as unknown as QuestionStatus;
      const qId = params.row.refCode;
      const qContentId = params.row.id;

      if (!questionGroupType) return null;
      return (
        <QContentListRowMoreActionMenu
          category={questionGroupType}
          status={questionGroupStatus}
          qId={qId}
          qContentId={qContentId}
          groupId={qContentId}
          shouldRedirectTo='questionGroup'
        />
      );
    },
  },
];
